<script lang="ts">
  import H from '$lib/components/H.svelte';
  import MaterialIcon from '$lib/MaterialIcon.svelte';

  import { mdiPencilBoxOutline } from '@mdi/js';
  import { dateString } from 'shared/src/utils/date.utils';
  import { titleCase } from 'shared/src/utils/titleCase';
  import { createEventDispatcher } from 'svelte';

  export let licenseType: 'group' | 'testing';
  export let quantity: number;
  export let starts: Date;
  export let months: 6 | 12;

  let clazz = '';
  export { clazz as class };

  interface $$Events {
    backToEditDetails: null;
  }
  const dispatch = createEventDispatcher<$$Events>();
</script>

<div class="grid grid-cols-2 sm:grid-cols-4 {clazz}">
  <div class="p-2 col-span-full bg-green relative">
    <H level={3} class="text-white text-xl font-medium text-center px-4">License Details:</H>
    <div class="absolute top-1 right-1">
      <button
        on:click={() => {
          dispatch('backToEditDetails');
        }}
      >
        <MaterialIcon class="text-white" path={mdiPencilBoxOutline} />
      </button>
    </div>
  </div>

  <div class="card-padding">
    <span class="font-medium block">Type:</span>
    {titleCase(licenseType)} License
  </div>
  <div class="card-padding"><span class="font-medium block">Seats:</span> {quantity}</div>
  <div class="card-padding">
    <span class="font-medium block">Starts:</span>
    {titleCase(dateString(starts, true, { month: 'short', day: 'numeric', year: 'numeric' }))}
  </div>
  <div class="card-padding">
    <span class="font-medium block">Duration:</span>
    {months === 6 ? 'Six months' : 'One year'}
  </div>
</div>

<style lang="postcss">
  table {
    @apply my-6;
    th,
    td {
      @apply text-left py-1 px-2;
    }
    /* tr {
      @apply border-b border-gray;
    }
    th {
      @apply border-l border-gray;
    } */
  }
  p {
    @apply my-4;
  }
</style>
